<template>
  <div class="alert blackout  profile-wrap">
    <div class="bg"></div>
    <div class="popup">
      <div class="title">
        <div class="close">
          <a @click.prevent="alertClosePopup()">
            <img src="/img/profile/close-x.svg"/>
          </a>
        </div>
      </div>
      <div class="popup-body">
        Til að innskrá þig með Facebook þarftu að uppfæra Bílaskrá appið.
      </div>
      <hr class="hr"/>
      <div class="footer">
        <div class="btn btn-success" @click.prevent="okBtn">ok</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    okBtn(){
      this.$store.state.fbModuleAlert = null;
      let appLink = 'https://play.google.com/store/apps/details?id=com.bilaskra.app';
      if(this.$device.ios()){
        appLink = 'https://apps.apple.com/app/apple-store/id1489190302?pt=120497884&ct=BilaskraApp&mt=8';
      }
      window.open(appLink, '_system');
    },
    alertClosePopup() {
        this.$store.state.fbModuleAlert = null;
    }
  }
};
</script>


<style scoped lang="less">
.alert{
  .bg{
    position: fixed;
    top: -95px;
    left: -12px;
    z-index: 12;
    opacity: 0.8;
    width: 100vw;
    height: 100vh;
    background: black;
  }
  font-size: 18px;
  color: black;
  width: 80%;
}
</style>